export enum UploaderUserType {
  Client = 'CLIENT',
  Pro = 'PRO',
}

export enum WellKnownDocumentTypeShortId {
  FinalReturn = 'FINAL_RETURN',
  FinalReturnToBeMailed = 'FINAL_RETURN_TO_BE_MAILED',
  DraftReturn = 'DRAFT_RETURN',
  ExtensionConfirmation = 'EXTENSION_CONFIRMATION',
  EFileConfirmation = 'E_FILE_CONFIRMATION',
  PriorYearReturn = 'PRIOR_YEAR_RETURN',
  Identification = 'ID',
  AnnotatedSourceDocument = 'ANNOTATED_SOURCE_DOCUMENT',
  Other = 'OTHER',
  PrepNotes = 'PREP_NOTES',
  ReviewNotes = 'REVIEW_NOTES',
  ExtensionRejectionConfirmation = 'EXTENSION_REJECTION_CONFIRMATION',
}

export interface DocumentTypeDTO {
  id: string
  short_id: string
  name: string
  heading: string
  short_help_text: string
  long_help_text: string
  image_url: string | null
  preview_url: string | null
  uploader_user_type: UploaderUserType
  extraction_schemas?: string[]
  fields?: Array<DocumentTypeFieldDTO>
}

export interface GetManyDocumentTypesPayload {
  ids: readonly string[]
}

export type DocumentTypeFieldDTO = {
  id: string
  label: string
  required?: boolean
  description?: string
  sort_order: number
} & (
  | {
      type: 'BOOL' | 'TEXT' | 'DATE'
    }
  | {
      type: 'NUMERIC'
      is_integer?: boolean
    }
  | {
      type: 'OBJECT' | 'ARRAY'
      fields: Array<DocumentTypeFieldDTO>
    }
)
